<template>
    <div class="new-banner">
      <div class="new-banner__content"  :style="{backgroundImage: 'url('+bgImage+')'}">
        <div class="title">
          Viltu vinna <span class="price">100.000 kr.?</span>
        </div>
        <div class="block">Segðu okkur hvað</div>
        <div class="block yellow">skiptir þig máli</div>
        <div class="block">við leit á bíl?</div>

        <router-link class="button" to="/skiptirmali">
          Taktu þátt
        </router-link>
      </div>
    </div>
</template>

<script>
import host from "@/helpers/getBaseUrl";

export default {
  computed: {
    bgImage() {
      return `${host()}/img/banner/banner-new.png`
    }
  }
}
</script>